import { TUpdateAttendancePayload } from "src/shared/types/api.types";
import { TEventAttendance } from "src/components/feature/homepageFlow/event-attendance/types.event-attendance";

export function createEventAttendancePayload(args: {
  attendance: TEventAttendance;
  isReservationEnabled: boolean;
}) {
  const { attendance, isReservationEnabled } = args;

  const payload = {} as TUpdateAttendancePayload;
  payload.eventCode = attendance?.event?.eventCode;
  payload.optInResponse = attendance?.optInResponse;

  if (attendance?.event?.optedIn !== null) {
    payload.previousOptInResponse = attendance?.event?.optedIn;
  }

  if (isReservationEnabled && typeof attendance?.seatCount === "number") {
    const seatCount = attendance?.optInResponse ? attendance?.seatCount : 0;
    payload.seatCount = seatCount;
  }

  if (attendance?.isSecondaryConfirmation) {
    payload.secondaryOptIn = attendance?.optInResponse;
  }

  return payload;
}
